/*NOTE: string型 name・type プロパティと、
        配列string型 path のプロパティを持っているオブジェクトの配列型
*/
export default [
  {
    //NOTE: キューブテクスチャ（環境マップ）は立方体の6面に対応する6枚の画像が必要
    // そのため、path を 配列型にする必要がある
    name: 'environmentMapTexture',
    type: 'cubeTexture',
    path:
    [
      'textures/environmentMap/px.jpg', // 右
      'textures/environmentMap/nx.jpg', // 左
      'textures/environmentMap/py.jpg', // 上
      'textures/environmentMap/ny.jpg', // 下
      'textures/environmentMap/pz.jpg', // 前
      'textures/environmentMap/nz.jpg'  // 後
    ]
  },
  // Perlin Pattern テクスチャ
  {
    name: 'perlinTexture0',
    type: 'texture',
    path:  'textures/perlinPattern/perlin_0.png'
  },
  // Book のページ画像（bookContent.js の source 名と対応）
  {
    name: 'bookTech0',
    type: 'texture',
    path: 'image/book/book_tech_0.jpg'
  },
  // Volumetric Fire Texture
  {
    name: 'volumetricFireTexture',
    type: 'texture',
    path: 'textures/volumetricFire/firetex.png'
  },
  {
    name: 'volumetricFirePerlinTexture',
    type: 'texture',
    path: 'textures/volumetricFire/nzw.png'
  },
  // Ame & bonfirebonfire (no fire)
  {
    name: 'ameAndBonfireNoFire',
    type: 'gltfModel',
    path: 'models/ame_with_bonfire_nofire/ame.gltf'
  },
  // TV Model
  {
    name: 'tvModel',
    type: 'gltfModel',
    path: 'models/tv/tv.gltf'
  },
  // Signalscope の望遠鏡モデル（.glb は GLTFLoader がそのまま読める）
  {
    name: 'telescopeModel',
    type: 'gltfModel',
    path: 'models/telescope/Telescope.glb'
  },
  // 惑星上空に浮かぶ人工衛星モデル
  {
    name: 'satelliteModel',
    type: 'gltfModel',
    path: 'models/satellite/Satellite.glb'
  },
  // サテライトをタップすると空を横切る UFO たち
  {
    name: 'ufoGreenSpaceship',
    type: 'gltfModel',
    path: 'models/ufo/alien_green_spaceship.glb'
  },
  {
    name: 'ufoJetpackGo',
    type: 'gltfModel',
    path: 'models/ufo/alien_jetpack_go.glb'
  },
  {
    name: 'ufoFlyingSaucer',
    type: 'gltfModel',
    path: 'models/ufo/flying_saucer.glb'
  },
  // 焚き火のアイコン画像
  {
    name: 'bonfireIcon',
    type: 'texture',
    path: 'image/bonfire_icon.png'
  },
  // Audio files
  // BGM
  {
    name: 'mainBGM',
    type: 'audio',
    path: 'audio/bgm/bgm_main_outer_wilds.mp3'
  },
  // Bonfire sound
  {
    name: 'bonfireSound',
    type: 'audio',
    path: 'audio/bonfire/fire_crackling_loop_5.wav'
  },
  // SE sound
  {
    name: 'clickSound_0',
    type: 'audio',
    path: 'audio/se/simple_click_0.wav'
  },
  {
    name: 'on_sound_0',
    type: 'audio',
    path: 'audio/se/button_on_25.wav'
  },
  {
    name: 'off_sound_0',
    type: 'audio',
    path: 'audio/se/button_off_26.wav'
  },
  {
    name: 'satelliteOutgoingSE',
    type: 'audio',
    path: 'audio/se/satellite_outgoing.mp3'
  },
  {
    name: 'ufoRockBreakSE',
    type: 'audio',
    path: 'audio/se/ufo_rock_break.mp3'
  },
  {
    name: 'ufoWarpSE',
    type: 'audio',
    path: 'audio/se/ufo_warp.mp3'
  },
  {
    name: 'ufoUpSE',
    type: 'audio',
    path: 'audio/se/ufo_up.mp3'
  },
  {
    name: 'bookPageTurnSE',
    type: 'audio',
    path: 'audio/se/book_page_turn_01.wav'
  },
  {
    name: 'bookPageTurn2SE',
    type: 'audio',
    path: 'audio/se/book_page_turn_02.wav'
  },
  {
    name: 'scopeSwitchSE',
    type: 'audio',
    path: 'audio/se/scope_switch.wav'
  },
  // Video files — TV に流す作品動画。配列順が Works カルーセルの REC 01〜03 に対応
  // （元素材の .mov から 960x720/30fps/無音 に変換済み。変換元は git 管理外）
  {
    name: 'tvVideo1',
    type: 'video',
    path: 'video/rec_1.mp4'
  },
  {
    name: 'tvVideo2',
    type: 'video',
    path: 'video/rec_2.mp4'
  },
  {
    name: 'tvVideo3',
    type: 'video',
    path: 'video/rec_3.mp4'
  }
]